import { RootState, _ } from "common";
import { createSelector } from "reselect";

const selectUserAffiliateState = (state: RootState) => state.UserAffiliate;

const selectUserAffiliateVouchers = createSelector(
  selectUserAffiliateState,
  (state) => state.userAffiliateVouchers
);

const selectIsUserAffiliateVouchersLoading = createSelector(
  selectUserAffiliateState,
  (state) => state.isUserAffiliateVouchersLoading
);

const selectIsUserAffiliateDetailsLoading = createSelector(
  selectUserAffiliateState,
  (state) => state.isUserAffiliateDetailsLoading
);

const selectUserAffiliateDetails = createSelector(
  selectUserAffiliateState,
  (state) => state.getUserAffiliateDetailsResponse
);

const selectGetUserAffiliateDetailsPayload = createSelector(
  selectUserAffiliateState,
  (state) => state.getUserAffiliateDetailsPayload
);

export const selectors = {
  selectUserAffiliateVouchers,
  selectGetUserAffiliateDetailsPayload,
  selectUserAffiliateDetails,
  selectIsUserAffiliateVouchersLoading,
  selectIsUserAffiliateDetailsLoading,
};
